import { Menu } from 'lucide-react';

export interface HamburgerMenuButtonProps {
  onClick: () => void;
  showBadge?: boolean;
  variant?: 'default' | 'compact';
  /** Extra classes appended to the variant styles (e.g. alignment nudges). */
  className?: string;
}

const styles = {
  default: 'relative p-1 -ml-1 text-foreground cursor-pointer',
  compact:
    'relative flex items-center justify-center size-[44px] rounded-md text-foreground cursor-pointer',
} as const;

const badgeStyles = {
  default: 'absolute top-0 right-0 w-1.5 h-1.5 rounded-full bg-danger',
  compact: 'absolute top-[8px] right-[5px] w-1.5 h-1.5 rounded-full bg-danger',
} as const;

const iconSize = { default: 22, compact: 24 } as const;

export function HamburgerMenuButton({
  onClick,
  showBadge = false,
  variant = 'default',
  className = '',
}: HamburgerMenuButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[styles[variant], className].filter(Boolean).join(' ')}
      aria-label="Open menu"
    >
      <Menu size={iconSize[variant]} />
      {showBadge && <span className={badgeStyles[variant]} />}
    </button>
  );
}
